import { Component } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css'],
})
export class PricingComponent {
  pricingList = [
    {
      key: 'basic',
      price: '500',
      sessions: 1,
      features: [0, 1, 2]
    },
    {
      key: 'pro',
      price: '1500',
      sessions: 4,
      features: [0, 1, 2]
    },
    {
      key: 'enterprise',
      price: null,
      sessions: null,
      features: [0, 1, 2]
    }
  ];
}